import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import is from '@sindresorhus/is';
import type { FunctionComponent } from 'react';
import { useContext } from 'react';

import { ApplicationContext } from '~/shared/context/context';
import { useConsentQuery } from '~/shared/query-hooks/consent';

import { route as onboardingRoutes } from '../pages/onboarding/constants';
import { route } from './route';
import { NoConsentDialog, TermsForm } from './TermsForm';

const disableConsentDialogRoutes = [onboardingRoutes.patterns.onboarding];

export const ConsentDialog: FunctionComponent = () => {
    const { applicationState, translate } = useContext(ApplicationContext);
    const consentQuery = useConsentQuery();
    const declinedConsent = applicationState.locationSearchParams.get(route.searchParams.decline) === 'true';
    const { pathname } = applicationState.location;

    if (disableConsentDialogRoutes.includes(pathname)) {
        return null;
    }

    if (declinedConsent) {
        return <NoConsentDialog />;
    }

    if (is.undefined(consentQuery.data?.status) || consentQuery.data.status === 'yes') {
        return null;
    }

    return (
        <Dialog aria-label="Terms consent dialog" open={true}>
            <DialogTitle variant="h4">{translate('dialogs.terms.title')}</DialogTitle>
            <TermsForm consentStatus={consentQuery.data.status} />
        </Dialog>
    );
};
